import { ArticleStatus, MarketPlace, ProductCardStatus } from "@/api/types/main/schemas";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Detail } from "./detail";
import { Section } from "./section";
import { LifeCycleStatusForm } from "../forms/life.cycle.status.form";
import { Star } from "lucide-react";
import { getMarketplaceIcons } from "@/lib/utils";
import StatusAmSelectForm from "../forms/status.am.select.form";
import { PromotionsCard } from "./promotions.card";

interface ProductDetailProps {
  detail: {
    name: string;
    marketplace: MarketPlace;
    category: string;
    sku: number;
    generalArticle: number;
    company: string;
    manager: string;
    productCardRating: number;
    productCardReviewsAmount: number;
    productCardStatus: ProductCardStatus;
    articleStatus: ArticleStatus;
    price: number;
    priceWithSpp: number;
    priceWithCard: number;
    skleikaRating: number;
    marketingCampaigns: string[];
  };
}

export const ProductDetail = ({ detail }: ProductDetailProps) => {
  return (
    <Card className="h-full min-h-0 overflow-auto">
      <CardHeader>
        <CardTitle>Детали</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-y-3">
        <Section title="Общее">
          <Detail label="Название" value={detail.name} />
          <Detail label="Категория" value={detail.category} />
          <Detail label="Артикул карточки" value={detail.sku} />
          <Detail label="Общий артикул" value={detail.generalArticle} />
          <Detail label="Юр. лицо" value={detail.company} />
          <Detail label="Менеджер" value={detail.manager} />
          <Detail
            label="Маркетплейс"
            value={
              <>
                {detail.marketplace} {getMarketplaceIcons(detail.marketplace)}
              </>
            }
          />

          <Detail
            label="Рейтинг"
            value={
              <>
                {detail.productCardRating} <Star color="gold" fill="gold" size={20} />
              </>
            }
          />
          <Detail
            label="Рейтинг в склейке"
            value={
              detail.skleikaRating ? (
                <>
                  {detail.skleikaRating} <Star color="gold" fill="gold" size={20} />
                </>
              ) : (
                "-"
              )
            }
          />
          <Detail label="Отзывов" value={detail.productCardReviewsAmount} />
        </Section>
        <Section title="Статусы">
          <Detail
            label="Статус карточки"
            value={<StatusAmSelectForm statusAm={detail.productCardStatus} />}
          />
          <Detail
            label="Статус товара"
            value={<LifeCycleStatusForm status={detail.articleStatus} />}
          />
        </Section>
        <Section title="Цена">
          <Detail label="Текущая цена" value={<>₽ {detail.price}</>} />
          <Detail label="Цена с картой" value={<>₽ {detail.priceWithCard}</>} />
          <Detail label="Цена с СПП" value={<>₽ {detail.priceWithSpp}</>} />
        </Section>
        <Section title="Акции">
          {detail.marketingCampaigns.length > 0 ? (
            <PromotionsCard
              promotions={detail.marketingCampaigns}
              marketplace={detail.marketplace}
            />
          ) : (
            <div className="flex justify-center mt-2">Нет активных акций</div>
          )}
        </Section>
      </CardContent>
    </Card>
  );
};
